/**
 * Testimonial Carousel
 *
 * Lightweight vanilla JS carousel for the testimonial block.
 * Supports prev/next navigation, counter display, and screen reader announcements.
 */

const initTestimonialCarousels = () => {
	const carousels = document.querySelectorAll('[data-testimonial-carousel]');

	carousels.forEach((carousel) => {
		if (carousel.dataset.testimonialInitialized) return;

		const slides = carousel.querySelectorAll('.block-testimonial__slide');
		const prevBtn = carousel.querySelector('[data-testimonial-prev]');
		const nextBtn = carousel.querySelector('[data-testimonial-next]');
		const counter = carousel.querySelector('[data-testimonial-counter]');
		const total = slides.length;
		let current = 0;

		if (total <= 1) return;

		const showSlide = (index) => {
			if (index === current) return;

			const incoming = slides[index];
			const outgoing = slides[current];

			// Cross-fade: outgoing fades out while incoming fades in simultaneously.
			// requestAnimationFrame ensures the browser has painted the incoming slide
			// at opacity:0 before we flip it to opacity:1, so the transition actually fires.
			outgoing.classList.remove('is-active');
			outgoing.setAttribute('aria-hidden', 'true');

			requestAnimationFrame(() => {
				incoming.classList.add('is-active');
				incoming.removeAttribute('aria-hidden');
			});

			current = index;

			if (counter) {
				counter.textContent = `${current + 1} / ${total}`;
			}
		};

		if (prevBtn) {
			prevBtn.addEventListener('click', () => {
				const prev = current === 0 ? total - 1 : current - 1;
				showSlide(prev);
			});
		}

		if (nextBtn) {
			nextBtn.addEventListener('click', () => {
				const next = current === total - 1 ? 0 : current + 1;
				showSlide(next);
			});
		}

		carousel.dataset.testimonialInitialized = 'true';
	});
};

// DOM ready
document.addEventListener('DOMContentLoaded', initTestimonialCarousels);

// Gutenberg block preview support
if (window.acf) {
	window.acf.addAction('render_block_preview/type=testimonial', initTestimonialCarousels);
}
